import Vue from 'vue'
import Vuex from 'vuex'

import createLogger from 'vuex/dist/logger'

import base from './modules/base'
import account from './modules/account'
import status from './modules/status'

Vue.use(Vuex)

// const debug = false //process.env.NODE_ENV !== 'production'
const debug = false
export default new Vuex.Store({
  modules: {
    base,
    account,
    status,
    strict: false, //debug
    plugins: debug ? [createLogger()] : []
  }
})
